import React from "react";

export function TabBtn({ active, onClick, testId, icon: Icon, iconColor, children }) {
  return (
    <button onClick={onClick} data-testid={testId}
      className={`flex items-center gap-1.5 sm:gap-2 px-2.5 sm:px-4 py-1.5 sm:py-2 rounded-xl text-[11px] sm:text-xs font-bold transition-all duration-150 ${active ? "bg-purple-600/20 text-purple-200 border border-purple-500/50 shadow-[0_0_14px_rgba(147,51,234,0.25)]" : "text-zinc-400 border border-transparent hover:text-white hover:bg-[var(--ag7-surface-2)] hover:border-[var(--ag7-border-soft)]"}`}>
      <Icon className={`w-3.5 h-3.5 sm:w-4 sm:h-4 ${iconColor}`} />
      <span>{children}</span>
    </button>
  );
}
